import React from "react";
import { useState, useEffect, useRef } from "react";
import { gsap } from "gsap";


// //Dropmenu

const navData = [
  {
    title: "Who We Are",
    link: "/about",
    tag: "menuon_whoweare",
    children: [
      {
        title: "Company Info.",
        link: "/about",
        tag: "menuon_whoweare_about",
      },
      {
        title: "History",
        link: "/history",
        tag: "menuon_whoweare_history",
      },
      {
        title: "Locations",
        link: "/location/domestic",
        tag: "menuon_whoweare_location",
        subChildren: [
          {
            title: "Domestic",
            link: "/location/domestic",
            tag: "menuon_location_domestic",
          },
          {
            title: "Overseas",
            link: "/location/overseas",
            tag: "menuon_location_overseas",
          },
        ],
      },
    ],
  },
  {
    title: "Why We Exist",
    link: "/whyweexist",
    tag: "menuon_whyweexist",
  },
  {
    title: "What We Do",
    link: "/sustainable-tech",
    tag: "menuon_whatwedo",
    children: [
      {
        title: "Virtual Showroom",
        link: "/showroom",
        tag: "menuon_whatwedo_showroom",
      },
      {
        title: "Sustainable Technologies",
        link: "/sustainable-tech",
        tag: "menuon_whatwedo_sustainable-tech",
      },
      {
        title: "Products & Services",
        link: "/product/space",
        tag: "menuon_whatwedo_product",
        subChildren: [
          {
            title: "Space",
            link: "/product/space",
            tag: "menuon_product_space",
          },
          {
            title: "Air",
            link: "/product/air",
            tag: "menuon_product_air",
          },
          {
            title: "Land",
            link: "/product/land",
            tag: "menuon_product_land",
          },
          {
            title: "Sea",
            link: "/product/sea",
            tag: "menuon_product_sea",
          },
        ],
      },
    ],
  },
];

const setTagging = (tag) => {
  console.log("Tag:", tag);
};

const Header = () => {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [sideMenu, setsideMenu] = useState(null);
  const barRef = useRef(null);
  const [scrollDirection, setScrollDirection] = useState("");

  useEffect(() => {
    
  if (hoveredMenu) {
    document.body.classList.add("menu-open");
  } else {
    document.body.classList.remove("menu-open");
  }

  return () => {
    document.body.classList.remove("menu-open");
  };
}, [hoveredMenu]);

const handleHover = (e, menu) => {
  setHoveredMenu(menu);

  const target = e.currentTarget;

  gsap.to(barRef.current, {
    width: target.offsetWidth,
    x: target.offsetLeft,
    duration: 0.4,
    ease: "power3.out",
  });
};

const handleLeave = () => {
  setHoveredMenu(null);

  gsap.to(barRef.current, {
    width: 0,
    duration: 0.3,
    ease: "power3.out",
  });
};


useEffect(() => {
  let lastScrollY = window.scrollY;
const handleScroll = () => {
  const currentScrollY = window.scrollY;

  if (currentScrollY !== 0) {
    if (currentScrollY > lastScrollY) {
      // scrolling down
      setScrollDirection("down");
    } else {
      // scrolling up
      setScrollDirection("up");
    }
  } else {
    setScrollDirection("");
  }

  lastScrollY = currentScrollY;
};
  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);

  return (
   <div className="header">
  <header className={`header translated ${sideMenu ? "is-side-menu" : ""} ${hoveredMenu ? "is-open" : ""} ${scrollDirection}`} id="header">
      <div className="header-inner">
        <a href="/" className="home">
        </a>

        <div className="gnb-wrap" style={
    sideMenu
      ? { opacity: 0, visibility: "hidden" }
      : { opacity: 1, visibility: "inherit" }
  }>
          <span ref={barRef} className="gnb-bar"></span>
          <ul className="gnb">
            <li
          className={`d1 btn3-en ${
            hoveredMenu === "company" ? "is-hover" : ""
          }`}
           onMouseEnter={(e) => handleHover(e, "company")}
          onMouseLeave={handleLeave}
        >
              <a className="d1-link" href="/company">Company</a>
              <div className="d2-wrap btn3-en">
                <ul className="d2-list">
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/about-us">About Us</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/evolution">Evolution</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/our-motivators">Leadership</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/clientele">Clientele</a></li>
                  {/* <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/partners">Partners</a></li> */}
                  {/* <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/testimonials">Testimonials</a></li> */}
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/quality-and-accreditations">Quality and Accreditations</a></li>
                </ul>

              </div>
            </li>
            {/* <li className="d1 btn3-en no-submenu">
              <a className="d1-link" href="/core-competencies">Core Competencies</a>
            </li> */}
            <li
          className={`d1 btn3-en ${
            hoveredMenu === "competencies" ? "is-hover" : ""
          }`}
           onMouseEnter={(e) => handleHover(e, "competencies")}
          onMouseLeave={handleLeave}
        >
          <a className="d1-link" href="/core-competencies">Core Competencies</a>
              <div className="d2-wrap btn3-en">
                <ul className="d2-list">
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/competencies/advanced-avionics-solutions">Advanced Avionics Solutions</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/competencies/select-custom-solutions">Select Custom Solutions</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/competencies/precise-time-and-frequency-solutions">Precise Time &amp; Frequency Solutions</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/competencies/control-solutions">Control Solutions</a></li>

                </ul>
              </div>
            </li>
            <li
          className={`d1 btn3-en ${
            hoveredMenu === "industries" ? "is-hover" : ""
          }`}
           onMouseEnter={(e) => handleHover(e, "industries")}
          onMouseLeave={handleLeave}
        >
              <a className="d1-link" href="/industries">Industries</a>
              <div className="d2-wrap btn3-en">
                <ul className="d2-list">
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/industries/space">Space</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/industries/sea">Sea</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/industries/land">Land</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/industries/air">Air</a></li>

                </ul>
              </div>
            </li>
            <li
          className={`d1 btn3-en ${
            hoveredMenu === "services" ? "is-hover" : ""
          }`}
           onMouseEnter={(e) => handleHover(e, "services")}
          onMouseLeave={handleLeave}
        >
              <a className="d1-link" href="/services">Services</a>
              <div className="d2-wrap btn3-en">
                <ul className="d2-list">
                  <li className="d2-item btn1-en">
                    <a className="d2-link btn1-kr" target="_self" href="/concept-to-realization-of-futuristic-products">Concept to Realization of Futuristic Products
                    </a>
                  </li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/legacy-upgrade">Legacy Upgrade</a></li>

                </ul>
              </div>
            </li>
            <li
          className={`d1 btn3-en ${
            hoveredMenu === "sustainability" ? "is-hover" : ""
          }`}
           onMouseEnter={(e) => handleHover(e, "sustainability")}
          onMouseLeave={handleLeave}
        >
              <a className="d1-link" href="/sustainability">Sustainability</a>
              <div className="d2-wrap btn3-en">
                <ul className="d2-list">
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/make-in-india">Make in India</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/safety-first">Safety First</a></li>
                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/investing-on-people">Investing on People</a></li>

                  <li className="d2-item btn1-en"><a className="d2-link btn1-kr" target="_self" href="/environmental-safety">Environmental Safety</a></li>
                </ul>
              </div>
            </li>
            <li className="d1 btn3-en no-submenu">
              <a className="d1-link" href="/careers">Careers</a>
            </li>
            <li className="d1 btn3-en no-submenu">
              <a className="d1-link" href="/contact">Contact</a>
            </li>
          </ul>
        </div>

        <div className="menu menu-utilities btn4-en">
                <a href="/" class="menu__region u-link"></a>
          <div className="menu__hamburger u-link init" onClick={() => setsideMenu(!sideMenu)}>

            <div className="icon">
              <svg id="menu-top" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                <g transform="translate(-989 -89)">
                  <g transform="translate(989 89)">
                    <rect data-name="rect" opacity="0"></rect>
                    <g data-name="menu" transform="translate(-379.5 -33.25)">
                      <path data-name="menu-top" d="M20,.75H0V-.75H20Z" fill="#fff" transform="translate(380.5 44.25)"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <svg id="menu-mid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                <g transform="translate(-989 -89)">
                  <g transform="translate(989 89)">
                    <rect data-name="rect" opacity="0"></rect>
                    <g data-name="menu" transform="translate(-379.5 -33.25)">
                      <path data-name="menu-mid" d="M20,.75H0V-.75H20Z" fill="#fff" transform="translate(380.5 44.25)"></path>
                    </g>
                  </g>
                </g>
              </svg>
              <svg id="menu-bot" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                <g transform="translate(-989 -89)">
                  <g transform="translate(989 89)">
                    <rect data-name="rect" opacity="0"></rect>
                    <g data-name="menu" transform="translate(-379.5 -33.25)">
                      <path data-name="menu-bot" d="M20,.75H0V-.75H20Z" fill="#fff" transform="translate(380.5 44.25)"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </header>
{/* /////////  
// Drop-Down Menu 
// ////// */}
  <div
      className="nav-map pb-b2"
        style={
    sideMenu
      ? { opacity: 1, visibility: "inherit" }
      : { opacity: 0, visibility: "hidden" }
  }
    >
      <div className="nav-map__inner">
        <ul className="nm">
          {navData.map((menu, index) => (
            <li className="nm__menu" key={index}>
              <a
                className="nm__d1-link btn1-en"
                href={menu.link}
                onClick={() => setTagging(menu.tag)}
              >
                <span>{menu.title}</span>
              </a>

              {menu.children && (
                <ul className="nm__list">
                  {menu.children.map((item, i) => (
                    <li className="nm__item" key={i}>
                      <a
                        className="nm__link btn2-en"
                        href={item.link}
                        style={{ "--fz": 16 }}
                        onClick={() => setTagging(item.tag)}
                      >
                        <span>{item.title}</span>
                      </a>

                      {item.subChildren && (
                        <ul className="nm__sub">
                          {item.subChildren.map((sub, j) => (
                            <li className="nm__sub-item" key={j}>
                              <a
                                className="nm__sub-link btn4-en"
                                href={sub.link}
                                onClick={() => setTagging(sub.tag)}
                              >
                                <span>{sub.title}</span>
                              </a>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
   </div>
  );
};

export default Header;